import React from 'react';
import LockIcon from '@mui/icons-material/Lock';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import BusinessIcon from '@mui/icons-material/Business';
import PeopleIcon from '@mui/icons-material/People';

const Topbar = ({ user, onLogout, activeTab, onMenuClick }) => {
  if (!user) return null;

  const getDisplayName = (tab) => {
    switch (tab) {
      case 'dashboard': return 'Risk & Compliance';
      case 'she': return 'SHE Compliance';
      case 'risks': return 'Risk Registers';
      case 'assessment': return 'Risk Assessment';
      case 'controls': return 'Controls & Treatment';
      case 'montecarlo': return 'Monte Carlo Analysis';
      case 'bcm': return 'Business Continuity';
      case 'reports': return 'Analysis & Reports';
      case 'losses': return 'Loss Events';
      default: return tab.replace('-', ' ');
    }
  };

  return (
    <header className="topbar glass">
      <div className="topbar-left" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        {/* Mobile Toggle Button - visibility controlled by CSS */}
        <button 
          className="mobile-menu-btn" 
          onClick={onMenuClick}
          style={{ 
            background: 'transparent', 
            border: 'none', 
            color: 'white', 
            cursor: 'pointer',
            padding: '8px'
          }}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
        </button>
        <h1 className="topbar-title" style={{ textTransform: 'capitalize', margin: 0 }}>
          {getDisplayName(activeTab)}
        </h1>
      </div>
      
      <div className="topbar-right">
        <div className="user-info-brief hide-on-mobile">
          <div className="user-details" style={{ marginRight: '15px' }}>
            <span className="user-name" style={{ fontWeight: 700, fontSize: '13px', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '8px' }}>
              <PersonIcon style={{ fontSize: '16px' }} />
              {user.name || 'User Account'}
            </span>
            <span className="user-email" style={{ fontSize: '11px', opacity: 0.8, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '6px', marginTop: '2px' }}>
              <EmailIcon style={{ fontSize: '12px' }} />
              {user.email}
            </span>
          </div>
        </div>
        
        <button className="btn-logout-top" onClick={onLogout} title="Logout">
          <LockIcon style={{ fontSize: '16px' }} />
          <span className="logout-text hide-on-mobile">Logout</span>
        </button>
      </div>
    </header>
  );
};

export default Topbar;
